// extracted by mini-css-extract-plugin
module.exports = {"bb-money-handles-new":"bb-money-handles-new__BLLLG"};